// extracted by mini-css-extract-plugin
module.exports = {"content":"aAS_pvzO","noFooter":"Kp2dVIAu","footer":"HzF9T_Cg","errorMessage":"GE1F8MqJ","dowJonesDisclaimer":"nUlUEKXq"};